import { gql } from "~/__generated__"

export const NEARBY_LOCATIONS_QUERY = gql(/* GraphQL */ `
  query NearbyLocations($latitude: Float!, $longitude: Float!, $distance: Float!) {
    nearbyLocations(latitude: $latitude, longitude: $longitude, distance: $distance) {
      edges {
        node {
          id
          name
          latitude
          longitude
          streetAddress
          city
          stateProvince
          distance
        }
      }
    }
  }
`)
